module.exports = __webpack_public_path__ + "img/01_noff_close_L1.b9ca5432.svg";